import { Pipe, PipeTransform } from '@angular/core';
import { getTimeFromSeconds } from 'src/app/core/utils/generic-utils';

@Pipe({
    name: 'durationFormat',
    standalone: false
})
export class DurationFormatPipe implements PipeTransform {
  transform(seconds: number): string {
    const formatted = getTimeFromSeconds(seconds);
    return `${this.padStart(formatted.hours)}:${this.padStart(
      formatted.minutes
    )}:${this.padStart(Math.floor(formatted.seconds))}`;
  }
  private padStart(n: number) {
    return n.toString().padStart(2, '0');
  }
}
